import { cn } from '@/lib/utils'
import styles from './Skeleton.module.scss'

/**
 * Loading placeholder. Translucent shimmer on `surface-raised`, never a
 * solid block. The bounded shape sits on `surface-raised`; a thin
 * highlight band traverses it on a 1.4s cycle. Borders are not
 * animated. Keyframes (`@keyframes skeleton-shimmer`) live with the
 * CSS module so build tooling scopes the animation name and keyframes
 * together.
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn(styles.skeleton, className)} {...props} />
}

export { Skeleton }
